export const money = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  const num = typeof n === "number" ? n : Number(n);
  if (Number.isNaN(num)) return String(n);
  return num.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
};

export const pct = (n, digits = 1) => {
  if (n === null || n === undefined || n === "") return "—";
  return `${Number(n).toFixed(digits)}%`;
};

export const dashify = (s) => s?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const statusLabel = {
  draft: "Draft",
  researching: "Researching",
  info_needed: "Info Needed",
  needs_verification: "Needs Verification",
  awaiting_approval: "Awaiting Approval",
  ready_for_submission: "Ready to Submit",
  approved: "Approved",
  final: "Final",
};

export const statusTone = {
  draft: "bg-slate-100 text-slate-700 border-slate-300",
  researching: "bg-blue-50 text-blue-800 border-blue-200",
  info_needed: "bg-amber-50 text-amber-800 border-amber-200",
  needs_verification: "bg-amber-50 text-amber-800 border-amber-200",
  awaiting_approval: "bg-brass-50 text-brass-700 border-brass-100",
  ready_for_submission: "bg-emerald-50 text-emerald-800 border-emerald-200",
  approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  final: "bg-navy text-white border-navy",
};
